import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Image from 'app/Components/Shared/Image/image';
import './ReplaceSimToEsimPage.scss';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../../Shared/Popup/PopUp';
import { validateField, validateForm } from '../../../../../utilities/validation/formValidation';
import { goToPage, setEmail, reportDWH } from '../../EsimUpgradeBlockSlice';
import { createEsimOrderAsync, createMemoAsync, sendSecondMagicLink } from '../../EsimUpgradeBlockAsyncThunk';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import alertIcon from './images/alert-icon.svg';

const ReplaceSimToEsimPage = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(props.isDisplayWhatIsEsimPopup);
    const [isDisplaySupportedDevicePopup, setDisplaySupportedDevicePopup] = useState(false);

    const showAgreementCheckbox = props.isDisplayReplaceSimCheckbox;

    const [formData, setFormData] = useState({
        email: { value: '', error: '', validationRules: { required: true, requiredMessage: 'נא הזן דואר אלקטרוני', regexName: 'emailRegex', regexMessage: 'דואר אלקטרוני לא תקין' } },
        isConfirmCheckbox: { value: false, error: '', validationRules: { required: showAgreementCheckbox, requiredMessage: 'יש לאשר כדי להמשיך' } },
    });

    useEffect(() => {
        gtag4({ event: 'EsimUpgrade_Step2_OfferPage', step: '2', action: 'OfferPage' });
        props.reportDWH({ actionType: 'eSIM Service Page', status: 'Ongoing', messageText: 'eSIM Service Page Displayed' });
    }, []);

    const formatSubscriberNo = (phone) => {
        if (!phone || phone.length < 10) return phone || '';
        return `${phone.slice(0, 3)}-${phone.slice(3)}`;
    };

    const renderAgreementLabel = () => (
        <>
            קראתי ואני מסכים ל{' '}
            <a href={props.termsOfServiceUrl} target='_blank' rel='noopener noreferrer' onClick={(e) => e.stopPropagation()}>
                תנאי השירות
            </a>
        </>
    );

    return (
        <div className='esim-upgrade-replace-sim-to-esim-page-wrapper'>
            <div className='esim-upgrade-replace-sim-to-esim-page'>

                <div className='info-banner'>
                    הנחיות להפעלת ה-eSIM יישלחו במייל וב-SMS בסיום התהליך
                </div>

                <div className='page-titles'>
                    <div className='title'>החלפה ל-eSIM / שחזור eSIM קיים</div>
                    <div className='sub-title'>למספר {formatSubscriberNo(props.subscriberNo)}</div>
                </div>

                <div className='product-card'>
                    <div className='product-card-header'>
                        <span className='product-card-title'>מעבר ל-eSIM / שחזור eSIM</span>
                        <span className='product-card-price'>
                            {displayPrice(props.esimPrice) == 0 ? (
                                'ללא עלות'
                            ) : (
                                <>
                                    {displayPrice(props.esimPrice)}<span className='nis'>₪</span>
                                    <span className='price-text'> חד פעמי</span>
                                </>
                            )}
                        </span>
                    </div>
                    <div className='product-card-row'>
                        <span className='product-card-row-icon'>
                            <Image src={alertIcon} alt='' />
                        </span>
                        <span className='product-card-row-text'>חשוב לוודא שהמכשיר תומך ב-eSIM</span>
                    </div>
                </div>

                <div className='links-wrapper'>
                    <a href='#' className='link-item' onClick={(e) => { e.preventDefault(); setIsDisplayPopup(true); }}>מה זה eSIM?</a>
                    <a href='#' className='link-item' onClick={(e) => { e.preventDefault(); setDisplaySupportedDevicePopup(true); }}>האם המכשיר שלי תומך ב-eSIM?</a>
                </div>

                <div className='email-section'>
                    <div className='email-title'>לאיזה מייל לשלוח את הוראות ההפעלה ל-eSIM?</div>
                    <div className='field-wrapper'>
                        <TextInput
                            className='email-input-field'
                            value={formData.email.value}
                            error={formData.email.error}
                            placeholder='מייל'
                            id='email'
                            name='email'
                            type='email'
                            disabled=''
                            required='required'
                            maxLength='40'
                            autoComplete='off'
                            onChange={(e) => handleOnChange('email', e.target.value)}
                        />
                    </div>
                    <div className='remark'>
                        {
                            props.isJet && props.primaryEmail ? (
                                <> למייל זה {props.primaryEmail} ישלח סיכום עסקה </>
                            ) : (
                                <> למייל זה ישלח סיכום עסקה </>
                            )
                        }
                    </div>

                    {showAgreementCheckbox && (
                        <div className='checkbox-wrapper'>
                            <CheckBox
                                checked={formData.isConfirmCheckbox.value}
                                id='isConfirmCheckbox'
                                error={formData.isConfirmCheckbox.error}
                                onChange={() => onToggleAgreement(!formData.isConfirmCheckbox.value)}>
                                {renderAgreementLabel()}
                            </CheckBox>
                        </div>
                    )}
                </div>

                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text='אישור והזמנה'
                        onclick={handlePageContinue}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>

            </div>

            <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: () => setIsDisplayPopup(false) }}>
                <div className='popup-esim'>
                    <div className='popup-title'>מה זה eSIM?</div>
                    <div className='custom-scrollbar'>
                        <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.whatIsEsimPopupText }}></div>
                    </div>
                    <div className='popup-link-wrapper'>
                        <a href='#' onClick={(e) => handleCellularDevicesClick(e)}>האם המכשיר שלי תומך ב-eSIM?</a>
                    </div>
                </div>
            </PopUp>

            <PopUp showPopUp={isDisplaySupportedDevicePopup} onClose={() => setDisplaySupportedDevicePopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: () => setDisplaySupportedDevicePopup(false) }}>
                <div className='popup-esim'>
                    <div className='popup-title'>בואו נבדוק אם המכשיר שלך תומך</div>
                    <div className='custom-scrollbar'>
                        <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.isDeviceSupportEsimPopupText }}></div>
                    </div>
                </div>
            </PopUp>

        </div>
    );

    function handleOnChange(fieldName, value) {
        let data = formData;
        const error = validateField(data[fieldName].validationRules, value);
        data[fieldName].error = error;
        data[fieldName].value = value;
        setFormData({ ...data });
    }

    function displayPrice(price) {
        if (typeof price === 'number') {
            return parseFloat(price.toFixed(2));
        }
        const res = parseFloat(parseFloat(price).toFixed(2));
        return isNaN(res) ? 0 : res;
    }

    function onToggleAgreement(isChecked) {
        formData.isConfirmCheckbox.value = isChecked;
        formData.isConfirmCheckbox.error = isChecked ? '' : 'יש לאשר כדי להמשיך';
        setFormData({ ...formData });
    }

    function handlePageContinue() {
        const result = validateForm(formData);
        setFormData({ ...result.form });
        if (!result.isValid) { return; }

        gtag4({ event: 'EsimUpgrade_Step2_OfferButton', step: '2', action: 'OfferButton' });
        props.reportDWH({ actionType: 'eSIM Service Page', status: 'Ongoing', messageText: 'eSIM Service Page Button Clicked' });

        props.setEmail(formData.email.value);

        if (props.magicLinkParameters?.clientName?.toUpperCase() == 'SAP') {
            props.sendSecondMagicLink();
        }

        if (props.magicLinkParameters?.sourceSystem == 'TALKMAN' || props.magicLinkParameters?.sourceSystem == 'AMDOCS') {
            props.createMemoAsync();
        }

        props.createEsimOrderAsync();
    }

    function handleCellularDevicesClick(e) {
        e.preventDefault();
        setIsDisplayPopup(false);
        setDisplaySupportedDevicePopup(true);
    }
};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimUpgradeBlock.loginDetails.subscriberNo,
        esimPrice: state.esimUpgradeBlock.esimPrice,
        primaryEmail: state.esimUpgradeBlock.checkUserResponse.primaryEmail,
        isJet: state.esimUpgradeBlock.checkUserResponse.isJet,
        whatIsEsimPopupText: state.esimUpgradeBlock.esimBlockData.whatIsEsimPopupText,
        isDeviceSupportEsimPopupText: state.esimUpgradeBlock.esimBlockData.isDeviceSupportEsimPopupText,
        cellularDevicesSupportedUrl: state.esimUpgradeBlock.esimBlockData.cellularDevicesSupportedUrl,
        isDisplayWhatIsEsimPopup: state.esimUpgradeBlock.esimBlockData.isDisplayWhatIsEsimPopup,
        isDisplayReplaceSimCheckbox: state.esimUpgradeBlock.esimBlockData.isDisplayReplaceSimCheckbox,
        termsOfServiceUrl: state.esimUpgradeBlock.esimBlockData.termsOfServiceUrl,
        magicLinkParameters: state.authentication.loginData.magicLinkParameters
    };
};

const mapDispatchToProps = {
    goToPage,
    setEmail,
    reportDWH,
    createEsimOrderAsync,
    createMemoAsync,
    sendSecondMagicLink
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplaceSimToEsimPage);
